
import appdata from '@/mixins/appdata'
import statecities from '@/mixins/defaults/statecities'

const addressesApi = {
  mixins: [ appdata, statecities ],
  data: () => ({
    addressValid: false,
    editingLoading: false,
    editingTimeOut: null,
    editingOldValue: {}
  }),
  watch: {
    address: {
      deep: true,
      handler (newValue) {
        clearTimeout(this.editingTimeOut)
        this.editingTimeOut = setTimeout(function () {
          this.loadSave(newValue)
          this.$emit('update', newValue)
          this.editingOldValue = Object.assign({}, newValue)
        }.bind(this), 545)
      }
    },
    externalApi: {
      deep: true,
      handler (newValue) {
        const data = newValue.transport
        if (data && data.data) {
          switch (data.type) {
            case 1:
              this.address.address = (data.data.address ? data.data.address[0] : '')
              this.address.neighborhood = (data.data.neighborhood ? data.data.neighborhood[0] : '')
              this.address.state = (data.data.state ? data.data.state[0] : '')
              this.address.city = (data.data.city ? data.data.city[0] : '')
              if (typeof this.address.num === 'undefined' || this.address.num.length === 0) this.$refs['addressNum' + this.index].focus()
              break
            case 2:
              this.address.cep = data.data.cep || ''
              this.address.neighborhood = data.data.neighborhood || ''
              break
          }
        }
        this.editingLoading = false
      }
    }
  },
  methods: {
    loadSave (newValue) {
      let oldValue = Object.assign({}, this.editingOldValue)
      const cep = this.address.cep
      const cepLen = (cep ? cep.length : 0)
      if (newValue.cep !== oldValue.cep && cepLen === 9) this.loadCep()
      const address = this.address.address || ''
      const num = this.address.num || ''
      const state = this.address.state || ''
      const city = this.address.city || ''
      if (state) this.cities = this.brasil[state].cities
      if (newValue.address !== oldValue.address || newValue.num !== oldValue.num || newValue.state !== oldValue.state || newValue.city !== oldValue.city) {
        if (address.length > 0 && num.length > 0 && state.length > 0 && city.length > 0) this.loadAddress({ address, num, state, city })
      }
    },
    loadCep (event) {
      console.log('toggle load cep')
      this.editingLoading = true
      setTimeout(function () { this.editingLoading = false }.bind(this), 4545)
      if (event) event.preventDefault()
      var cep = this.address.cep.trim().replace(/[^0-9]/g, '')
      this.$store.dispatch('loadCep', { cep: cep })
    },
    loadAddress ({ address, num, state, city }) {
      console.log('toggle load address')
      this.editingLoading = true
      setTimeout(function () { this.editingLoading = false }.bind(this), 4545)
      this.$store.dispatch('loadAddress', { address: address, num: num, uf: state, city: city })
    },
    addressSave () {
      if (this.$refs['addressSaveForm' + this.index].validate()) {
        this.$emit('saveAddress', { index: this.index, address: this.address })
      }
    }
  },
  created () {
    // this.loadSave(this.address)
  }
}

export default addressesApi
